import App from './App';
import trackingConsole from './utils/trackingConsole';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import store from "./redux/store";
import ErrorBoundary from './ErrorBoundary';
import './assets/scss/theme.scss';
import 'simplebar/dist/simplebar.min.css';
import 'tippy.js/animations/scale.css';
// import { getReferrerUrlAction, getUserAgentAction, updateAnalyticsAndAffiliateInfo } from './redux/ducks/analytics';
// import { autoLogin } from './redux/ducks/auth';
// import { getOrchestrator, initOrchestratorVersionListeners } from './redux/ducks/orchestrator';
//import AppWrapper from './AppWrapper';
import logger from './utils/logger';
// import Intercom from '@intercom/messenger-js-sdk';
import LogRocket from 'logrocket';
import { requestSanitizer, responseSanitizer } from './utils/logRocketUtils';
import TagManager from 'react-gtm-module';
import { getErrorMessage } from './utils/errorUtils';
import { installHistoryMutationLog } from './utils/historyMutationLog';
import { installFunnelRouteDepartureWatch } from './utils/funnelRouteUtils';
// import TrackingService from './services/TrackingService';

console.log('REACT_APP_VERSION:', process.env.REACT_APP_VERSION);

// installed before anything else can navigate, so the record covers the whole document's history
try {
	installHistoryMutationLog();
	// dumps the record, with stacks, whenever the app leaves /f, /fc or /e - a departure nobody asked for
	// is otherwise unattributable after the fact
	installFunnelRouteDepartureWatch();
} catch (err) {
	logger.logErrorEvent('HISTORY_MUTATION_LOG_INITIALIZATION', err, getErrorMessage(err), true);
}

try {
	const tagManagerArgs = { gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID };
	TagManager.initialize(tagManagerArgs);
} catch (err) {
	logger.logErrorEvent('GTM_INITIALIZATION', err, getErrorMessage(err), true);
}

try {
	LogRocket.init(process.env.REACT_APP_LOGROCKET_ID, {
		release: process.env.REACT_APP_VERSION,
		shouldDebugLog: false,
		dom: {
			baseHref: 'https://app.readyrx.com/',
		},
		network: {
			requestSanitizer: requestSanitizer,
			responseSanitizer: responseSanitizer,
		},
	});
} catch (err) {
	logger.logErrorEvent('LOG_ROCKET_INITIALIZATION', err, getErrorMessage(err), true);
}

// Initial dispatches
// store.dispatch(getOrchestrator());
// store.dispatch(autoLogin());
// store.dispatch(getReferrerUrlAction());
// store.dispatch(getUserAgentAction());

// const unsubscribeOrchestratorListeners = initOrchestratorVersionListeners(store);

const root = createRoot(document.getElementById('root'));
root.render(
	<ErrorBoundary>
		<Provider store={store} stabilityCheck='never'>
			<App />
		</Provider>
	</ErrorBoundary>
);

// if (module.hot) {
// 	module.hot.dispose(() => {
// 		unsubscribeOrchestratorListeners();
// 	});
// }